import { render, staticRenderFns } from "./elImageCustom.vue?vue&type=template&id=089c30a2"
import script from "./elImageCustom.vue?vue&type=script&lang=js"
export * from "./elImageCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports